import ClientsFilter from './ClientsFilter';

export default ClientsFilter;
